/* eslint-disable react/jsx-filename-extension,no-undef */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Routes from './components/Routes/Routes';
import registerServiceWorker from './helpers/registerServiceWorker';
import './index.css';
import store from './store';
import './styles/flat-ui.min.css';

ReactDOM.render(
  <Provider store={store} ><Routes /></Provider>,
  document.getElementById('root'),
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js